import "./Profile.css";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../lib/AuthContext";

export default function Profile() {
    const { user, logout } = useAuth();
    const navigate = useNavigate();

    const handleLogout = () => {
        logout();
        navigate("/user/Auth");
    };

    return (
        <div className="profileContainer">
            <h2>Profile</h2>

            <div className="profileSection">
                <strong>Name:</strong> <p>{user.name}</p>
            </div>

            <div className="profileSection">
                <strong>Email:</strong> <p>{user.email}</p>
            </div>
            <div className="profileSection">
                <button onClick={handleLogout}>Logout</button>
            </div>
        </div>
    );
}